<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="rule-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>

                    <div class="rule-view">
                        <h5>竞猜规则</h5>
                        <div class="rule-item"><div class="label">1</div>MPL邀请赛竞猜活动时间为2025年11月12日10:00-11月28日18:00</div>
                        <div class="rule-item"><div class="label">2</div>比赛赛制为双败制</div>
                        <div class="rule-item"><div class="label">3</div>仙术师需按顺序依次选择您认为的晋级队伍，选择完后点击【提交竞猜】按钮提交您的竞猜</div>
                        <div class="rule-item"><div class="label">4</div>选择队伍错误可刷新页面重选，提交竞猜后无法重新选择</div>
                        <div class="rule-item"><div class="label">5</div>竞猜结果正确即可获得对应序号奖励，与前面的竞猜无关，例如竞猜1错误，竞猜3正确，仍可获得奖励3</div>
                        <div class="rule-item"><div class="label">6</div>竞猜奖励将在活动结束后10个工作日内游戏内直接发放，无需手动领取
                            （奖励6-2025星赛季纪念坐骑将于1月中旬游戏版本更新后发放）</div>
                    </div>

                    <div class="rule-view">
                        <h5>全明星赛规则</h5>
                        <div class="rule-item"><div class="label">1</div>活动时间为2025年11月12日10:00-11月28日18:00</div>
                        <div class="rule-item"><div class="label">2</div>票选期间，每位仙术师可以按1~5号位自由挑选支持的选手，组成全明星赛出战阵容</div>
                        <div class="rule-item"><div class="label">3</div>两方阵营票数最高的明星选手将受邀参加电魂娱乐星赛季全明星表演赛</div>
                        <div class="rule-item"><div class="label">4</div>当某位选手得票数皆为两阵营最高时，将代表支持率更高的一方阵营出战，另一方阵营将由该阵营支持率第二的选手出战</div>
                    </div>                    

                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style scoped>
.rule-modal{
    width: 585px;
    background-color: #fcfbfa;
    border: 3px solid #fff;
    font-size: 24px;
    color: #525b65;
    z-index: 1001;
    box-sizing: border-box;
}

.title{
    width: 126px;
    height: 32px;
    margin: 0 auto 20px;
    background-image: url(~@/assets/images/modal/title-rule.png);    
}

.rule-view{
    padding: 0 34px;
    text-align: left;
    color: #787264;
    font-size: 16px;
    line-height: 1.6;
}

h5{
    font-size: 24px;
    margin-bottom: 20px;
}

img{
    display: block;
    margin: 20px auto 30px;
}

.rule-view b{
    color: #fe5a1e;
}

.rule-item{
    position: relative;
    padding-left: 40px;
    margin-bottom: 10px;
}

.label{
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    width: 17px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    background-color: #bf552a;
    color: #fff;
    font-size: 12px;
    margin-right: 10px;
}
</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    methods : {
        destroyElement () {
            this.$destroy();
            document.body.style.overflow = ''; // 出现滚动条
            this.$el.parentNode.removeChild(this.$el)
        },       
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>